import { render, staticRenderFns } from "./ReminderDocuments.vue?vue&type=template&id=7fa42044"
import script from "./ReminderDocuments.vue?vue&type=script&lang=ts"
export * from "./ReminderDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa42044')) {
      api.createRecord('7fa42044', component.options)
    } else {
      api.reload('7fa42044', component.options)
    }
    module.hot.accept("./ReminderDocuments.vue?vue&type=template&id=7fa42044", function () {
      api.rerender('7fa42044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ReminderDocuments.vue"
export default component.exports